import { createActions, createReducer } from "reduxsauce"
import * as Immutable from "seamless-immutable"
// import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
// const tag = '[SAGA_CONTACT_REDUX]'; // eslint-disable-line

const functionDefinitions = {
  /*---------- createHisobusContact --------*/
  requestCreateHisobusContact: ["contact"],
  createHisobusContactSuccess: ["createHisobusContactResponse"],
  createHisobusContactFailure: ["createHisobusContactError"],

  /*---------- createPartnerRequest --------*/
  requestCreatePartnerRequest: ["request"],
  createPartnerRequestSuccess: ["createPartnerRequestResponse"],
  createPartnerRequestFailure: ["createPartnerRequestError"],

  /*---------- createBusinessRegister --------*/
  requestCreateBusinessRegister: ["business"],
  createBusinessRegisterSuccess: ["createBusinessRegisterResponse"],
  createBusinessRegisterFailure: ["createBusinessRegisterError"],

  /*---------- getAssuerInfo --------*/
  requestGetAssuerInfo: ["bookingID", "refId"],
  getAssuerInfoSuccess: ["getAssuerInfoResponse"],
  getAssuerInfoFailure: ["getAssuerInfoError"],

  /*---------- createAssuer --------*/

  requestCreateAssuer: ["assurerReq"],
  createAssuerSuccess: ["createAssuerResponse"],
  createAssuerFailure: ["createAssuerError"],

  /*---------- getAssurerGets --------*/

  requestGetAssurerGets: ["bookingNo"],
  getAssurerGetsSuccess: ["getAssurerGetsResponse"],
  getAssurerGetsFailure: ["getAssurerGetsError"],

  /*---------- deleteAssurerGets --------*/
  requestDeleteAssurerGets: ["id", "bookingId"],
  deleteAssurerGetsSuccess: ["deleteAssurerGetsResponse"],
  deleteAssurerGetsFailure: ["deleteAssurerGetsError"],

  /*---------- getCountries --------*/
  requestGetCountries: [],
  getCountriesSuccess: ["getCountriesResponse"],
  getCountriesFailure: ["getCountriesError"],

  /*---------- createEmployeeRequest --------*/
  requestCreateEmployee: ["employeeReq"],
  createEmployeeSuccess: ["createEmployeeResponse"],
  createEmployeeFailure: ["createEmploeyyError"]
}

const { Types, Creators } = createActions(functionDefinitions)

export const SagaContactTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const SagaContactInitState = {
  contactDetail: []
}

export const INITIAL_STATE = Immutable(SagaContactInitState)

/* ------------- Reducers ------------- */

/*---------- createHisobusContact --------*/
export const requestCreateHisobusContact = (state, action) => {
  return state.merge({
    createHisobusContactFetching: true,
    contact: action.contact
  })
}
export const createHisobusContactSuccess = (state, action) => {
  return state.merge({
    createHisobusContactFetching: false,
    createHisobusContactResponse: action.createHisobusContactResponse,
    createHisobusContactError: null
  })
}
export const createHisobusContactFailure = (state, action) => {
  return state.merge({
    createHisobusContactFetching: false,
    createHisobusContactError: action.createHisobusContactError
  })
}
/*---------- createPartnerRequest --------*/

export const requestCreatePartnerRequest = (state: Immutable, action) => {
  return state.merge({
    createPartnerRequestFetching: true,
    request: action.request
  })
}
export const createPartnerRequestSuccess = (state: Immutable, action) => {
  return state.merge({
    createPartnerRequestFetching: false,
    createPartnerRequestResponse: action.createPartnerRequestResponse
  })
}
export const createPartnerRequestFailure = (state: Immutable, action) => {
  return state.merge({
    createPartnerRequestFetching: false,
    createPartnerRequestError: action.createPartnerRequestError
  })
}

/*---------- createBusinessRegister --------*/

export const requestCreateBusinessRegister = (state: Immutable, action) => {
  return state.merge({
    createBusinessRegisterFetching: true,
    business: action.business
  })
}
export const createBusinessRegisterSuccess = (state: Immutable, action) => {
  return state.merge({
    createBusinessRegisterFetching: false,
    createBusinessRegisterResponse: action.createBusinessRegisterResponse
  })
}
export const createBusinessRegisterFailure = (state: Immutable, action) => {
  return state.merge({
    createBusinessRegisterFetching: false,
    createBusinessRegisterError: action.createBusinessRegisterError
  })
}

/*---------- getAssuerInfo --------*/

export const requestGetAssuerInfo = (state: Immutable, action) => {
  return state.merge({
    getAssuerInfoFetching: true,
    bookingID: action.bookingID,
    refId: action.refId,
    getAssuerInfoResponse: null,
    createAssuerResponse: null
  })
}
export const getAssuerInfoSuccess = (state: Immutable, action) => {
  return state.merge({
    getAssuerInfoFetching: false,
    getAssuerInfoResponse: action.getAssuerInfoResponse,
    getAssuerInfoError: null,
    createAssuerResponse: null
  })
}
export const getAssuerInfoFailure = (state: Immutable, action) => {
  return state.merge({
    getAssuerInfoFetching: false,
    getAssuerInfoError: action.getAssuerInfoError
  })
}

/*---------- createAssuer --------*/

export const requestCreateAssuer = (state: Immutable, action) => {
  return state.merge({
    createAssuerFetching: true,
    assurerReq: action.assurerReq,
    createAssuerError: null,
    createAssuerResponse: null
  })
}
export const createAssuerSuccess = (state: Immutable, action) => {
  return state.merge({
    createAssuerFetching: false,
    createAssuerResponse: action.createAssuerResponse,
    createAssuerError: null
  })
}
export const createAssuerFailure = (state: Immutable, action) => {
  return state.merge({
    createAssuerFetching: false,
    createAssuerError: action.createAssuerError
  })
}

/*---------- getAssurerGets --------*/

export const requestGetAssurerGets = (state: Immutable, action) => {
  return state.merge({
    getAssurerGetsFetching: true,
    bookingNo: action.bookingNo,
    getAssurerGetsError: null,
    getAssurerGetsResponse: null
  })
}
export const getAssurerGetsSuccess = (state: Immutable, action) => {
  return state.merge({
    getAssurerGetsFetching: false,
    getAssurerGetsResponse: action.getAssurerGetsResponse,
    getAssurerGetsError: null
  })
}
export const getAssurerGetsFailure = (state: Immutable, action) => {
  return state.merge({
    getAssurerGetsFetching: false,
    getAssurerGetsError: action.getAssurerGetsError
  })
}

/*---------- deleteAssurerGets --------*/
export const requestDeleteAssurerGets = (state, action) => {
  return state.merge({
    deleteAssurerGetsFetching: true,
    id: action.id,
    bookingId: action.bookingId,
    deleteAssurerGetsResponse: null,
    deleteAssurerGetsError: null
  })
}
export const deleteAssurerGetsSuccess = (state, action) => {
  return state.merge({
    deleteAssurerGetsFetching: false,
    deleteAssurerGetsResponse: action.deleteAssurerGetsResponse
  })
}
export const deleteAssurerGetsFailure = (state, action) => {
  return state.merge({
    deleteAssurerGetsFetching: false,
    deleteAssurerGetsError: action.deleteAssurerGetsError
  })
}

/*---------- getCountries --------*/
export const requestGetCountries = (state, action) => {
  return state.merge({
    getCountriesFetching: true
  })
}
export const getCountriesSuccess = (state, action) => {
  return state.merge({
    getCountriesFetching: false,
    getCountriesResponse: action.getCountriesResponse
  })
}
export const getCountriesFailure = (state, action) => {
  return state.merge({
    getCountriesFetching: false,
    getCountriesError: action.getCountriesError
  })
}

/*---------- createEmployee --------*/

export const requestCreateEmployee = (state: Immutable, action) => {
  return state.merge({
    createEmployeeFetching: true,
    employeeReq: action.employeeReq,
    createEmployeeError: null,
    createEmployeeResponse: null
  })
}
export const createEmployeeSuccess = (state: Immutable, action) => {
  return state.merge({
    createEmployeeFetching: false,
    createEmployeeResponse: action.createEmployeeResponse,
    createEmployeeError: null
  })
}
export const createEmployeeFailure = (state: Immutable, action) => {
  return state.merge({
    createEmployeeFetching: false,
    createEmployeeError: action.createEmployeeError
  })
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  /*---------- createHisobusContact --------*/
  [Types.REQUEST_CREATE_HISOBUS_CONTACT]: requestCreateHisobusContact,
  [Types.CREATE_HISOBUS_CONTACT_SUCCESS]: createHisobusContactSuccess,
  [Types.CREATE_HISOBUS_CONTACT_FAILURE]: createHisobusContactFailure,

  /*---------- createPartnerRequest --------*/

  [Types.REQUEST_CREATE_PARTNER_REQUEST]: requestCreatePartnerRequest,
  [Types.CREATE_PARTNER_REQUEST_SUCCESS]: createPartnerRequestSuccess,
  [Types.CREATE_PARTNER_REQUEST_FAILURE]: createPartnerRequestFailure,

  /*---------- createBusinessRegister --------*/

  [Types.REQUEST_CREATE_BUSINESS_REGISTER]: requestCreateBusinessRegister,
  [Types.CREATE_BUSINESS_REGISTER_SUCCESS]: createBusinessRegisterSuccess,
  [Types.CREATE_BUSINESS_REGISTER_FAILURE]: createBusinessRegisterFailure,

  /*---------- getAssuerInfo --------*/
  [Types.REQUEST_GET_ASSUER_INFO]: requestGetAssuerInfo,
  [Types.GET_ASSUER_INFO_SUCCESS]: getAssuerInfoSuccess,
  [Types.GET_ASSUER_INFO_FAILURE]: getAssuerInfoFailure,

  /*---------- createAssuer --------*/

  [Types.REQUEST_CREATE_ASSUER]: requestCreateAssuer,
  [Types.CREATE_ASSUER_SUCCESS]: createAssuerSuccess,
  [Types.CREATE_ASSUER_FAILURE]: createAssuerFailure,

  /*---------- getAssurerGets --------*/
  [Types.REQUEST_GET_ASSURER_GETS]: requestGetAssurerGets,
  [Types.GET_ASSURER_GETS_SUCCESS]: getAssurerGetsSuccess,
  [Types.GET_ASSURER_GETS_FAILURE]: getAssurerGetsFailure,

  /*---------- deleteBlogCategory --------*/
  [Types.REQUEST_DELETE_ASSURER_GETS]: requestDeleteAssurerGets,
  [Types.DELETE_ASSURER_GETS_SUCCESS]: deleteAssurerGetsSuccess,
  [Types.DELETE_ASSURER_GETS_FAILURE]: deleteAssurerGetsFailure,

  /*---------- getCountries --------*/
  [Types.REQUEST_GET_COUNTRIES]: requestGetCountries,
  [Types.GET_COUNTRIES_SUCCESS]: getCountriesSuccess,
  [Types.GET_COUNTRIES_FAILURE]: getCountriesFailure,

  /*---------- createEmployee --------*/
  [Types.REQUEST_CREATE_EMPLOYEE]: requestCreateEmployee,
  [Types.CREATE_EMPLOYEE_SUCCESS]: createEmployeeSuccess,
  [Types.CREATE_EMPLOYEE_FAILURE]: createEmployeeFailure
})



// WEBPACK FOOTER //
// ./src/redux/sagaContact/sagaContactRedux.ts